import * as React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";
import { CircularProgress } from "@material-ui/core";
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { fetchGet } from "../../api/fetch";

const MenuProps = {
  getContentAnchorEl: () => null,
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
};

const styles = {
  container: {
    display: "flex",
    height: "100%",
    '@media(max-width: 470px)': {
      flexDirection: "column"
    }
  },
  msContainer: {
    flexGrow: "1",
    display: "flex",
    '@media(max-width: 470px)': {
      flexDirection: "column",
      paddingLeft: "24px",
    }
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
  },
  inputFormControl: {
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #5f00a0",
      borderRadius: "2px"
    },
  },
  inputFormControlSites: {
    marginLeft: "24px",
    '@media(max-width: 470px)': {
      marginLeft: "0px",
      marginTop: "16px"
    }
  },
  inputSubtitle: {
    fontSize: "14px",
    fontWeight: "500",
    zIndex: "1000",
  },
  inputSelect: {
    width: "220px",
    height: "36px",
    fontSize: "14px",
    "& > .MuiOutlinedInput-input": {
      paddingLeft: "12px",
    },
    "& > .MuiSelect-icon": {
      right: "5px",
    },
    "& > fieldset > legend": {
      width: "0px",
    },
    '@media(max-width: 470px)': {
      width: "298px",
    }
  },
  menuItem: {
    height: "40px",
  },
  listItemText: {
    "& .MuiTypography-body1": {
      fontSize: "14px"
    }
  },
  confirmBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
    marginLeft: "32px",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  cancelBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
  },
}

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const MultiSelect = (props) => {
  const { classes } = props;

  const [nodeTree, setNodeTree] = React.useState([])
  const [sendingRequest, setSendingRequest] = React.useState(false);
  const [companies, setCompanies] = React.useState([])
  const [sites, setSites] = React.useState([])
  const [sectors, setSectors] = React.useState([])
  const [vmi, setVmi] = React.useState([])
  const [selectedCompanyId, setSelectedCompanyId] = React.useState(0)
  const [selectedSiteId, setSelectedSiteId] = React.useState(0)
  const [selectedSectorId, setSelectedSectorId] = React.useState(0)
  const [selectedVmiId, setSelectedVmiId] = React.useState(0)
  const [selectedSiteIndex, setSelectedSiteIndex] = React.useState(0)
  const [selectedSectorIndex, setSelectedSectorIndex] = React.useState(0)
  const [selectedVmiIds, setSelectedVmiIds] = React.useState([])

  React.useEffect(() => {
    try {
      fetchGet(`/vmi/companies/sectors/vmi`)
        .then(companies => {
          setNodeTree(companies)
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setSendingRequest(props.sendingRequest)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.sendingRequest]);


  const handleCompanyChange = (event) => {

    let selectedCompanyIndex = nodeTree.findIndex(obj => {
      return obj.name === event.target.value;
    })

    let selectedCompanyId = nodeTree[selectedCompanyIndex].id;
    if (event.target.value === "Select All") {
      setSelectedCompanyId(0)
      setSelectedSiteId(0)
      setSelectedSiteIndex(0)
      setSelectedSectorId(0)
      setSelectedSectorIndex(0)
      setSelectedVmiIds([])
    } else {
      setSelectedCompanyId(selectedCompanyId)

      let vmiIds = []
      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)];

      for (let i = 0; i < node.children.length; i++) {
        for (let j = 0; j < node.children[i].children.length; j++) {
          node.children[i].children[j].children.forEach(v => vmiIds.push(v.id))
        }
      }
      setSelectedVmiIds(vmiIds)
    }

    setSites([])
    setSectors([])
    setVmi([])

    const {
      target: { value },
    } = event;
    setCompanies(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleSiteChange = (event) => {
    if (event.target.value === I18n.get("common_all")) {
      console.log(event.target.value)
      setSelectedSiteId(0)
      setSelectedSiteIndex(0)
      setSelectedSectorId(0)
      setSelectedSectorIndex(0)
      setSelectedVmiIds([])

    } else {
      let siteIndex = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children.findIndex(obj => {
        return obj.name === event.target.value;
      })


      let vmiIds = []
      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[siteIndex];

      for (let i = 0; i < node.children.length; i++) {
        node.children[i].children.forEach(v => vmiIds.push(v.id))
      }
      setSelectedVmiIds(vmiIds)

      setSelectedSiteId(node.id)
      setSelectedSiteIndex(siteIndex)

    }

    setSectors([])
    setVmi([])

    const {
      target: { value },
    } = event;
    setSites(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleSectorChange = (event) => {

    if (event.target.value === I18n.get("common_all")) {

      let vmiIds = []

      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex];

      for (let i = 0; i < node.children.length; i++) {
        node.children[i].children.forEach(v => vmiIds.push(v.id))
      }
      setSelectedVmiIds(vmiIds)
      setSelectedSectorId(0)
      setSelectedSectorIndex(0)
    } else {
      let sectorIndex = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children.findIndex(obj => {
        return obj.name === event.target.value;
      })

      let vmiIds = []
      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children[sectorIndex];

      node.children.forEach(v => vmiIds.push(v.id))

      setSelectedVmiIds(vmiIds)

      setSelectedSectorId(node.id)
      setSelectedSectorIndex(sectorIndex)
    }
    setVmi([])

    const {
      target: { value },
    } = event;
    setSectors(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleVmiChange = (event) => {

    if (event.target.value === I18n.get("common_all")) {
      console.log(event.target.value)

      let vmiIds = []
      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children[selectedSectorIndex];

      node.children.forEach(v => vmiIds.push(v.id))

      setSelectedVmiIds(vmiIds)
      setSelectedVmiId(0)

    } else {
      let vmiIndex = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children[selectedSectorIndex].children.findIndex(obj => {
        return obj.name === event.target.value;
      })

      let node = nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children[selectedSectorIndex].children[vmiIndex];

      setSelectedVmiIds([node.id])
      setSelectedVmiId(node.id)
    }

    const {
      target: { value },
    } = event;
    setVmi(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleConfirm = () => {
    props.handleMultiSelect(selectedVmiIds)
  }

  return (
    <div className={classes.container}>
      <div className={classes.msContainer}>
        <div>
          <div className={classes.inputSubtitle}>{I18n.get("companies_company")}</div>
          <FormControl sx={{ m: 1, width: "300px" }} className={classes.inputFormControl}>
            <Select
              value={companies[0] ? companies : [I18n.get("common_all")]}
              onChange={handleCompanyChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
              className={classes.inputSelect}
              label="Label"
            >
              {[{ name: I18n.get("common_all") }, ...nodeTree]
                .map((company) => (
                  <MenuItem key={company.name} value={company.name} className={classes.menuItem}>
                    {company.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <div className={classes.inputFormControlSites}>
          <div className={classes.inputSubtitle}>{I18n.get("companies_site")}</div>
          <FormControl sx={{ m: 1, width: 300 }} className={classes.inputFormControl}>
            <Select
              disabled={!Boolean(selectedCompanyId)}
              value={sites[0] ? sites : [I18n.get("common_all")]}
              onChange={handleSiteChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
              className={classes.inputSelect}
            >
              {
                selectedCompanyId > 0 ?
                  [{ name: I18n.get("common_all") }, ...nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children]
                    .map((company) => (
                      <MenuItem key={company.name} value={company.name} className={classes.menuItem}>
                        {company.name}
                      </MenuItem>
                    ))
                  :
                  null
              }
            </Select>
          </FormControl>
        </div>
        <div className={classes.inputFormControlSites}>
          <div className={classes.inputSubtitle}>{I18n.get("sector")}</div>
          <FormControl sx={{ m: 1, width: 300 }} className={classes.inputFormControl}>
            <Select
              disabled={!Boolean(selectedSiteId)}
              value={sectors[0] ? sectors : [I18n.get("common_all")]}
              onChange={handleSectorChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
              className={classes.inputSelect}
            >
              {
                selectedSiteId > 0 ?
                  [{ name: I18n.get("common_all") }, ...nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children]
                    .map((company) => (
                      <MenuItem key={`${company.name} ${company.id}`} value={company.name} className={classes.menuItem}>
                        {company.name}
                      </MenuItem>
                    ))
                  :
                  null
              }
            </Select>
          </FormControl>
        </div>
        <div className={classes.inputFormControlSites}>
          <div className={classes.inputSubtitle}>{I18n.get("vmi").toUpperCase()}</div>
          <FormControl sx={{ m: 1, width: 300 }} className={classes.inputFormControl}>
            <Select
              disabled={!Boolean(selectedSectorId)}
              value={vmi[0] ? vmi : [I18n.get("common_all")]}
              onChange={handleVmiChange}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
              className={classes.inputSelect}
            >
              {
                selectedSectorId > 0 ?
                  [{ name: I18n.get("common_all") }, ...nodeTree[nodeTree.findIndex(n => n.id === selectedCompanyId)].children[selectedSiteIndex].children[selectedSectorIndex].children]
                    .map((company) => (
                      <MenuItem key={company.name} value={company.name} className={classes.menuItem}>
                        {company.name}
                      </MenuItem>
                    ))
                  :
                  null
              }
            </Select>
          </FormControl>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        {getWidth() < 478 ?
          <button
            className={`${classes.cancelBtn}`}
            onClick={() => props.setOpenFilter(false)}>
            {I18n.get("site_cancel").toUpperCase()}
          </button>
          :
          null
        }
        <button
          className={`${classes.confirmBtn} ${true === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
          onClick={() => handleConfirm()}>
          {!sendingRequest ? I18n.get("site_confirm").toUpperCase() : <CircularProgress size={16} style={{ 'color': 'white' }} />}
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    companies: get(state, ["companies"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MultiSelect))
);
